export default __webpack_public_path__ + "static/media/Path3442.31878f8e.svg";